import { Component, Input, OnInit } from '@angular/core';
import { ModalDismissReasons, NgbDateStruct, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { CaseService } from '../../services/case.service';
import { LookupService } from '../../services/lookup.service';
import { SharedHttpService } from '../../services/shared-http.service';
import { DateFormatterService } from '../date-picker/date-formatter.service';

@Component({
  selector: 'app-case-find',
  templateUrl: './case-find.component.html',
  styleUrls: ['./case-find.component.scss']
})
export class CaseFindComponent implements OnInit {
  TypeCaseFindArr: any;
  findtypeId: any;
  findstatusArr: any;
  findstatusId: any;
  findOrder: any;
  caseId: any;
  CaseFindArr:any;
  @Input() eCaseId:any;
  caseFindId: any;
  isInsert:boolean=false;
  dateOfFind: string;
  editedDate:NgbDateStruct;
  findTypeName: any;
  findStatusName: any;
  other:any;
  currentDate:NgbDateStruct;
  today = new Date();

  showAddPage : Boolean = false;
  showEditPage : Boolean = false;
  constructor(private dateformat: DateFormatterService, private modalService: NgbModal, public sharedService: SharedHttpService, public caseService: CaseService, private lookupService: LookupService, public toastr: ToastrService) { }

  ngOnInit(): void {
    this.currentDate=this.sharedService.convertDateToNgbDateStruct(this.today);

    this.isInsert=false;
    this.TypeCaseFindArr = this.lookupService.getLockup('findtype');
    this.findstatusArr = this.lookupService.getLockup('findstatus');
    this.caseId = this.caseService.case.caseId;  
//    this.eCaseId = this.caseService.case.eCaseId;  
this.loadDate();
  }
loadDate(){
  this.sharedService.get(`api/CaseFind/GetCaseFinds?eCaseId=${this.eCaseId}`).subscribe(res=>{
    this.CaseFindArr = res;
  })
}
  CraeteCaseFind(add) {
    this.findtypeId=undefined;
    this.findstatusId=undefined;
    this.findOrder=undefined;
    this.currentDate=this.sharedService.convertDateToNgbDateStruct(this.today);
    this.dateOfFind = this.dateformat.ToGregorian2(this.currentDate );
     
    this.other=undefined;
    this.isInsert=true;
    // this.sharedService.openLarge(add);
    this.showAddPage=true;
  }

  numberOnly(event) {
    var inp = String.fromCharCode(event.keyCode);
    let pattern =/^\d+$/;
    if (pattern.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }
  OnCraeteCaseFind() {
    let obj = {
      "caseId": this.caseId,
      "findTypeId": this.findtypeId,
      "findStatusId": this.findstatusId,
      "findOrder": this.findOrder,
      "dateOfFind": this.dateOfFind,
"other":this.other
    };
    this.sharedService.post(`api/CaseFind/Insert`, [obj]).subscribe(res => {
      // modal.dismiss('Cross click');
      this.showAddPage=false;
      this.sharedService.showSuccessKey("CaseFindAddedSuccessfully");
this.loadDate();
    
    });
  }

  editCaseFind(find,add){
    this.findTypeName=find.findTypeName;
    this.findStatusName=find.findStatusName;
    this.findtypeId=find.findTypeId;
    this.findstatusId=find.findStatusId;
    this.findOrder=find.findOrder;
this.dateOfFind=find.dateOfFind;
this.caseFindId=find.caseFindId;
this.other=find.other;

this.editedDate = this.sharedService.convertDateToNgbDateStruct(this.dateOfFind);

    this.isInsert=false;
    if(add){
      this.sharedService.openLarge(add);
    }else{
      this.showEditPage=true;
    }
  }
  SelectedDateChange($event) {
    this.dateOfFind = this.dateformat.ToGregorian2($event);
  }

  OnEditCaseFind(modal) {
    let obj = {
      "caseFindId": this.caseFindId,
      "caseId": this.caseId,
      "findTypeId": this.findtypeId,
      "findStatusId": this.findstatusId,
      "findOrder": this.findOrder,
      "dateOfFind": this.dateOfFind,
      "other":this.other

    };
    this.sharedService.put(`api/CaseFind/Update`, [obj]).subscribe(res => {
      // modal.dismiss('Cross click');
      this.showEditPage=false;
      this.sharedService.showSuccessKey("CaseFindEditSuccessfully");
this.loadDate();
    
    });
  }
  deleteCaseFind(caseFindId: any, mymodal) {
    this.sharedService.openSmall(mymodal);
    this.caseFindId = caseFindId;
  }


  onDeleteCaseFind(modal) {
    let url = 'api/CaseFind/Delete'
    this.sharedService.delete(url, [this.caseFindId]).subscribe(
      (response) => {
        modal.dismiss('Cross click');

      this.sharedService.showSuccessKey("CaseFindDeleteSuccessfully");
this.loadDate();
    
    },
     
    );
  }
}
